import React from "react";
import "./FeatureCard.css";

interface FeatureCardProps {
  iconSrc: string;
  label: string;
  body: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ iconSrc, label, body }) => {
  return (
    <div className="feature-card">
      <div className="icon-box">
        <img alt="Feature icon" src={iconSrc} />
      </div>
      <p className="feature-card-label mb-1.5">{label}</p>
      <p className="feature-card-body">{body}</p>
    </div>
  );
};

export default FeatureCard;
